// extracted by mini-css-extract-plugin
export default {"wrap":"ViewerProgressBar_wrap__2OKdI","inside":"ViewerProgressBar_inside__zcI-R"};